import isEqual from 'lodash/isEqual';
export const isFeatureCollection = (geoJson) => {
    return geoJson.type === 'FeatureCollection';
};
export const isFeature = (geoJson) => {
    return geoJson.type === 'Feature';
};
export const featureToFeatureCollection = (geoJSON) => ({
    type: 'FeatureCollection',
    features: geoJSON instanceof Array ? geoJSON : [geoJSON],
});
export const featureCollectionToFeature = (featureCollection) => {
    return featureCollection.features;
};
export const featuresAreEqual = (firstGeoJSON, secondGeoJSON) => {
    const firstAsFC = isFeatureCollection(firstGeoJSON) ? firstGeoJSON : featureToFeatureCollection(firstGeoJSON);
    const secondAsFC = isFeatureCollection(secondGeoJSON) ? secondGeoJSON : featureToFeatureCollection(secondGeoJSON);
    return isEqual(firstAsFC, secondAsFC);
};
export const hasFeatures = (featureCollection) => featureCollection && featureCollection.features && featureCollection.features.length > 0;
//# sourceMappingURL=featureCollections.js.map